import * as React    from 'react'
import * as ReactDOM from 'react-dom'
import { App }       from './ui/App'

// Render the app
ReactDOM.render(<App />, document.getElementById('root'))
